import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ModeStatus = ({ accessMode }) => {
  const { t } = useTranslation();

  const [color, setColor] = useState("");
  const [status, setStatus] = useState("");
  const [count, setCount] = useState("");

  useEffect(() => {
    if (accessMode) {
      const { mode, sudoLength } = accessMode;
      setStatus(mode === 0 ? "Read-Only " : "Sudo ");
      if (sudoLength > 0) {
        if ((mode === 1 && sudoLength > 1) || mode === 0) {
          setCount("(" + sudoLength.toString() + ")");
        }
      }
      let c = "coloredRed";
      if (mode === 0) {
        if (sudoLength > 0) {
          c = "coloredYellow";
        }
      } else if (mode === 1) {
        c = "colored";
      }
      setColor(c);
    }
  }, [accessMode]);

  return (
    <div className="BalanceText">
      <p> {t("Mode_status")}</p>
      {accessMode && (
        <div className="vertical-middle">
          <h3 className={color}>
            {status}
            {count}
          </h3>
        </div>
      )}
    </div>
  );
};

function modeAreEqual(prevProps, nextProps) {
  return (
    prevProps.accessMode.mode === nextProps.accessMode.mode &&
    prevProps.accessMode.sudoLength === nextProps.accessMode.sudoLength
  );
}

export default React.memo(ModeStatus, modeAreEqual);
